import Search from './Search';
import SearchResults from './SearchResults';

export default {
  Search,
  SearchResults,
}



// WEBPACK FOOTER //
// ./src/modules/search/components/index.js